/* @jsx h */
import { defineComponent, h, PropType } from "vue";
import type { ShopProfile } from "@lemmonhq/types";
import { formatPhone } from "@lemmonhq/orders";
import { useLocalization } from "@lemmonhq/uikit";

export const RestaurantSidebar = defineComponent({
  props: {
    restaurant: {
      type: Object as PropType<ShopProfile>,
      required: true,
    },
  },
  setup(props) {
    const { t } = useLocalization();
    return () => (
      <div class="space-y-8">
        <div class="border border-gray-200 rounded-lg p-6">
          <h3 class="text-lg font-serif font-medium text-gray-900 mb-4">
            {t("customer.restaurant_profile.contact_information")}
          </h3>
          <div class="space-y-3">
            <div class="flex items-start">
              <span class="material-symbols-outlined text-gray-400 mr-3 mt-1">
                location_on
              </span>
              <div class="text-gray-600 font-light">
                <a
                  href={`https://maps.google.com/?q=${encodeURIComponent(
                    props.restaurant?.geolocation?.address ||
                      props.restaurant.address,
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {props.restaurant.address}
                </a>
              </div>
            </div>

            {props.restaurant.phone && (
              <div class="flex items-center">
                <span class="material-symbols-outlined text-gray-400 mr-3">
                  call
                </span>
                <a
                  href={`tel:${props.restaurant.phone}`}
                  class="text-gray-600 hover:text-gray-900 font-light"
                >
                  {formatPhone(props.restaurant.phone)}
                </a>
              </div>
            )}

            {props.restaurant.socials?.website && (
              <div class="flex items-center">
                <span class="material-symbols-outlined text-gray-400 mr-3">
                  language
                </span>
                <a
                  href={props.restaurant.socials.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  class="text-gray-600 hover:text-gray-900 font-light"
                >
                  {t("customer.restaurant_profile.visit_website")}
                </a>
              </div>
            )}
          </div>
        </div>

        {props.restaurant.geolocation && (
          <div class="border border-gray-200 rounded-lg p-6">
            <h3 class="text-lg font-serif font-medium text-gray-900 mb-4">
              {t("customer.restaurant_profile.location")}
            </h3>
            <a
              href={`https://maps.google.com/?q=${encodeURIComponent(
                props.restaurant.geolocation.address ||
                  props.restaurant.address,
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              class="inline-flex items-center text-gray-600 hover:text-gray-900 font-light"
            >
              <span class="material-symbols-outlined text-sm mr-1">
                directions
              </span>
              {t("customer.restaurant_profile.get_directions")}
            </a>
          </div>
        )}
      </div>
    );
  },
});
